<template>
	<article class="dialog-window">
		<div class="dialog-header">
			<h2 v-if="title">{{ title }}</h2>
			<button
				type="button"
				@click="close"
			>
				<span class="sr-only">Dialoog sluiten</span>
				<IconSvg icon="close" />
			</button>
		</div>
		<div class="dialog-body">
			<slot></slot>
		</div>

		<div v-if="typeof $slots.footer !== 'undefined'" class="dialog-footer">
			<slot name="footer"></slot>
		</div>
	</article>
</template>

<script lang="ts" setup>
	import type {PropType} from 'vue';
	import type {DialogContextId} from '~/composables/useDialog';
	import {getDialogContext} from '~/composables/useDialog';
	import IconSvg from '~/components/generic/IconSvg.vue';

	const props = defineProps({
		title: {
			type: String,
			required: true
		},
		closeCheck: {
			type: Function,
			default: () => true
		},
		dialogContextId: {
			type: String as PropType<DialogContextId>,
			default: undefined
		}
	});

	const currentDialog = getDialogContext(props.dialogContextId);

	const close = () => {
		if (props.closeCheck()) {
			currentDialog.hide();
		}
	};
</script>

<style scoped>
	.dialog-window {
		background: #ffffff;

		height: var(--dialog-height, auto);
		width: var(--dialog-width, auto);
		max-height: var(--dialog-max-height, calc(100vh - 2em - 6px));
		max-width: var(--dialog-max-width, 740px);

		--dialog-padding-x: 20px;
		--dialog-padding-y: 22px;

		display: flex;
		flex-direction: column;
	}

	.dialog-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: var(--dialog-padding-y) var(--dialog-padding-x);
		border-bottom: 1px solid var(--color-grey-50);

		gap: var(--dialog-padding-x);

		flex: 0 0 auto;
	}

	.dialog-body {
		padding: var(--dialog-padding-y) var(--dialog-padding-x);
		flex: 0 1 auto;
		overflow: auto;
		overscroll-behavior: contain;
	}

	.dialog-header button {
		flex: 0 0 auto;
		--icon-size: 20px;
		border: none;
		background: none;
		cursor: pointer;
		padding: var(--dialog-padding-y) var(--dialog-padding-x);
		margin: calc(var(--dialog-padding-y) * -1) calc(var(--dialog-padding-x) * -1);
	}

	button:hover {
		color: var(--color-primary);
	}

	h2 {
		font-size: 20px;
		line-height: 1;
	}

	.dialog-footer {
		flex: 0 0 auto;
		padding: var(--dialog-padding-y) var(--dialog-padding-x);
	}
</style>
